
const state = {
  keyword: '' // 全部车辆列表，搜索关键字
}

const mutations = {
  'UPDATE_ALL_LIST_KEYWORD'(state, keyword) {
    state.keyword = keyword
  }
}

const actions = {
  UPDATE_ALL_LIST_KEYWORD({ commit }, keyword) {
    commit('UPDATE_ALL_LIST_KEYWORD', keyword)
  }
}
export default {
  state,
  actions,
  mutations
}
